// Webpack will replace 'environment-node' with 'environment-browser' in browser environments.
export * from '../src/modules/environment/environment-node';



// WEBPACK FOOTER //
// ./~/ws-scripts/modules/environment.js